export { default } from './Article';
export { default as relatedCardsAdapter } from '../RelatedCards/adapter';
export { default as RelatedCardsCarouselAdapter } from '../RelatedCards/adapter';
export { HIGHLIGHTED_CARD } from '../RelatedCards';
